module.exports = __webpack_public_path__ + "fonts/Inter-600-cyrillic58.fdccea7.woff2";